import card from "_texts/presentation/cards/cardcontactustitle.js";

const textProps = {
  heading3badge: {
    whiteContent: true,
    badge: {
      color: "teal",
      children: "Message us",
    },
    title: "Type in the bellow form",
    description:
      "They say there's no future for the street rascals, nothing for them, leave them to fall. But it isn't always how you would like it to be, especially when you do nothing for yourself.",
    alignment: "center",
  },
  card: {
    ...card,
  },
};
export default textProps;
